import { AgeRangeState, GetAgeRangeResponse } from 'Application/models';
import { fetchAgeRange } from 'Application/service';
import { create } from 'zustand';

export const useAgeRangeStore = create<AgeRangeState>((set) => ({
    isLoading: false,
    isError: false,
    error: null,
    ageRangeData: [],

    getAgeRange: async () => {
        set({ isLoading: true });

        try {
            const response: GetAgeRangeResponse = await fetchAgeRange();

            set({ isError: false, error: null, ageRangeData: response });
        } catch (error) {
            set({ error: 'Failed to get countries', isError: true });
            throw error;
        } finally {
            set({ isLoading: false });
        }
    }
}));
